import axios from "axios";
import Service from "../../Service";

const searchIconsQuery = (search: string) => `
query {
    search ( version: "latest", query: "${search}", first: 30 ) {
        id,
        label,
        membership{
            free
        }
    }
}`;

const allIconsQuery = `
query {
    release (version:"5.15.4"){
      icons ( license:"free" ){
              id,
        membership {
          free
        }
      }
    }
}`;

export async function ListarIconsFontAwesomeService(search?: string) {
    return Service(
        axios.post("https://api.fontawesome.com", {
            query: search ? searchIconsQuery(search) : allIconsQuery,
        })
    );
}
